import { getApi, putApi, postApi } from './Api';

export const saveMember = async (data) => {
  const url = `/admin/member`;
  try {
    const response = await postApi(url, data);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getMemberForHospital = async (id) => {
  const url = `/admin/member/all/hospital/${id}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getMemberList = async (count) => {
  const url = `/admin/member/all/page?page=${count}&size=15`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e; // 에러를 던져 호출한 곳에서 처리할 수 있게 합니다.
  }
};

export const getSerachMemberList = async (value, count) => {
  const url = `/admin/member/getMemberName/${value}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e; // 에러를 던져 호출한 곳에서 처리할 수 있게 합니다.
  }
};

export const dupleEmail = async (email) => {
  const url = `/admin/member/doctor-duple-email-check?email=${email}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e; // 에러를 던져 호출한 곳에서 처리할 수 있게 합니다.
  }
};

export const getMemberDetail = async (id) => {
  const url = `/admin/member/${id}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e; // 에러를 던져 호출한 곳에서 처리할 수 있게 합니다.
  }
};

export const updateMember = async (id, data) => {
  const url = `/admin/member/${id}`;
  try {
    const response = await putApi(url, data);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e; // 에러를 던져 호출한 곳에서 처리할 수 있게 합니다.
  }
};
